module.exports = __webpack_public_path__ + "img/bermuda_statue.5630cb7b.jpg";